import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Container, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Button, Grid, Select, MenuItem, FormControl, InputLabel, Chip, IconButton, TablePagination } from "@mui/material";
import { Edit as EditIcon, Delete as DeleteIcon, Visibility as ViewIcon } from "@mui/icons-material";
import Layout from "../components/layout/GSTlayout";
import { useSelector, useDispatch } from "react-redux";

const ClientDirectory = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const [filterIndustry, setFilterIndustry] = useState("all");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const selectedCompanyInfo = useSelector((state) => state.kyc.selectedCompanyInfo);
  const selectedAddress = useSelector((state) => state.kyc.selectedAddress);
  const selectedContactInfo = useSelector((state) => state.kyc.selectedContactInfo);
  const selectedBusinessInfo = useSelector((state) => state.kyc.selectedBusinessInfo);
  const selectedTaxInfo = useSelector((state) => state.kyc.selectedTaxInfo);


  


  if (!selectedCompanyInfo) {
    return "Select a company first";
  }

  const clients = [
    {
      id: 1,
      name: selectedCompanyInfo.legalName ||"NA",
      businessName: selectedCompanyInfo?.tradeName || "N/A",
      gstNumber: selectedTaxInfo?.vatGstNumber ||"NA",
      email: selectedContactInfo?.primaryContact?.email ||"NA",
      phone: selectedContactInfo?.primaryContact?.phone ||"NA",
      industryType: selectedBusinessInfo?.industry || "N/A",
      status: "active" ||"NA",
      address: selectedAddress?.operatingOffice?.street ||"NA",
    }
  ];
 

  const filteredClients = clients.filter((client) => {
    const matchesSearch =
      client.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      client.businessName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      client.gstNumber?.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesStatus =
      filterStatus === "all" || client.status?.toLowerCase() === filterStatus;

    const matchesIndustry =
      filterIndustry === "all" || client.industryType === filterIndustry;

    return matchesSearch && matchesStatus && matchesIndustry;
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleDelete =()=>{
    alert("Client Deleted Successfully");
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "active": return "success";
      case "pending": return "warning";
      case "inactive": return "error";
      default: return "default";
    }
  };

  return (
    <Layout>
      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom>Client Directory</Typography>
        
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Search Clients"
              variant="outlined"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Grid>
          <Grid item xs={6} md={4}>
            <FormControl fullWidth>
              <InputLabel>Status</InputLabel>
              <Select
                value={filterStatus}
                label="Status"
                onChange={(e) => setFilterStatus(e.target.value)}
              >
                <MenuItem value="all">All Status</MenuItem>
                <MenuItem value="active">Active</MenuItem>
                <MenuItem value="pending">Pending</MenuItem>
                <MenuItem value="inactive">Inactive</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} md={4}>
            <FormControl fullWidth>
              <InputLabel>Industry Type</InputLabel>
              <Select
                value={filterIndustry}
                label="Industry Type"
                onChange={(e) => setFilterIndustry(e.target.value)}
              >
                <MenuItem value="all">All Industries</MenuItem>
                <MenuItem value="Retail">Retail</MenuItem>
                <MenuItem value="Services">Services</MenuItem>
                <MenuItem value="Manufacturing">Manufacturing</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Paper sx={{ width: "100%", mb: 2 }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Client Name</TableCell>
                  <TableCell>Business Name</TableCell>
                  <TableCell>GST Number</TableCell>
                  <TableCell>Contact</TableCell>
                  <TableCell>Industry</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredClients
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((client) => (
                    <TableRow key={client.id}>
                      <TableCell>{client.name}</TableCell>
                      <TableCell>{client.businessName}</TableCell>
                      <TableCell>{client.gstNumber}</TableCell>
                      <TableCell>
                        {client.email}<br />
                        {client.phone}
                      </TableCell>
                      <TableCell>{client.industryType}</TableCell>
                      <TableCell>
                        <Chip
                          label={client.status}
                          color={getStatusColor(client.status)}
                          size="small"
                        />
                      </TableCell>
                      <TableCell align="right">
                        <IconButton
                          color="primary"
                          component={Link}
                          to={`/clients/view/${client.id}`}
                          size="small"
                        >
                          <ViewIcon />
                        </IconButton>
                        <IconButton
                          color="secondary"
                          component={Link}
                          to={`/clients/edit/${client.id}`}
                          size="small"
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          color="error"
                          onClick={() => handleDelete(client.id)}
                          size="small"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredClients.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>

        <Grid container justifyContent="flex-end" sx={{ mt: 2 }}>
          <Button
            variant="contained"
            color="primary"
            component={Link}
            to="/kycForm"
          >
            Add New Client
          </Button>
        </Grid>
      </Container>
    </Layout>
  );
};

export default ClientDirectory;
